import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentElement, AddressElement } from '@stripe/react-stripe-js';
import { useSubscriptionManagerContext } from '../../SubscriptionManager.context';
import { PAYMENT_ELEMENT_OPTIONS } from '../../SubscriptionManager.constants';
import { Button, Modal } from 'react-daisyui';
import { XMarkIcon } from '@heroicons/react/16/solid';

const AddPaymentMethodModal = (): ReactElement => {
  const { t } = useTranslation('settings/SubscriptionManager');

  const {
    showAddPaymentMethodModal,
    toggleAddPaymentMethodModal,
    addPaymentMethod,
    addingPaymentMethod,
    addPaymentMethodOptions,
  } = useSubscriptionManagerContext();
  // RET-2426: a caller that opened the add with its own button text (the
  // paused low-balance top-up: «Agregar y cobrar $25 USD») gets it here,
  // because this provider mounts the modal, not the caller. Anywhere else the
  // button says what it always said.
  const submitLabel =
    addPaymentMethodOptions?.submitLabel ??
    t('page.addPaymentMethodModal.save-payment-method');

  return (
    <Modal open={showAddPaymentMethodModal}>
      <Modal.Header className="flex flex-row justify-between">
        {t('page.addPaymentMethodModal.add-payment-method')}
        <XMarkIcon
          onClick={() => toggleAddPaymentMethodModal(false)}
          className="w-6 h-6 text-neutral my-auto cursor-pointer"
        />
      </Modal.Header>
      <Modal.Body className="grid justify-items-center">
        <form
          id="payment-form"
          className="min-w-full"
          onSubmit={() => addPaymentMethod()}
        >
          <PaymentElement options={PAYMENT_ELEMENT_OPTIONS} />
          <AddressElement options={{ mode: 'billing' }} />
        </form>
      </Modal.Body>
      <Modal.Actions>
        <Button
          color="primary"
          onClick={() => addPaymentMethod()}
          loading={addingPaymentMethod}
        >
          {submitLabel}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddPaymentMethodModal;
